import { useState } from 'react';
import { Helmet } from 'react-helmet';
import {
  Button,
  Card,
  Checkbox,
  Loader,
  Placeholder,
  Typography,
} from 'components';
import CalculatorBestOffer from 'components/CalculatorBestOffer/CalculatorBestOffer';
import { translate } from 'utils';
import s from './WelcomeBack.module.scss';
import useWelcomeBackNewApplication from './useWelcomeBackNewApplication';

export default function WelcomeBackNewApplication() {
  const {
    client,
    handleConfirm,
    amount,
    offer,
    constraints,
    handleAmountChange,
    pending,
    consent,
    consentsLoading,
  } = useWelcomeBackNewApplication();
  const [isConsentAccepted, setIsConsentAccepted] = useState(false);

  const handleConsentToggle = () =>
    setIsConsentAccepted((prevState: boolean) => !prevState);

  return (
    <>
      <Helmet>
        <title>{translate('welcome_back.html_title')}</title>
      </Helmet>

      <Typography className={s['card-title']} size="l" fontWeight={600}>
        {translate('welcome_back.title', { clientName: client?.firstName })}
      </Typography>

      <div className={s['box-wrapper']}>
        <Card className={s.card} dataTest="welcomeBack-newApplication-card">
          {constraints && offer ? (
            <>
              <CalculatorBestOffer
                calculatorAmount={amount}
                constraints={constraints.amountInterval}
                offer={offer}
                onAmountChange={handleAmountChange}
                disabledSlider={pending}
              />
              <Button
                dataTest="new-offer-btn"
                pending={pending}
                onClick={handleConfirm}
                className={s.continue}
                buttonClassName={s['continue-button']}
                disabled={!offer || !isConsentAccepted}
              >
                {translate('welcome_back.button')}
              </Button>
              <div data-test="current-offer-btn" className={s.link} />
            </>
          ) : (
            <Loader className={s.loader} />
          )}
        </Card>
      </div>
      <div className="xs:mx-5 px-5 lg:px-0" data-test="consent-section">
        <div
          className="text-text-primary text-[14px] font-medium mb-[10px] mt-[15px]"
          data-test="welcomeBack-consent-heading"
        >
          {translate('welcome_back.consent_heading')}
        </div>
        <Checkbox
          name="consent"
          className="[&_p:last-child]:-ml-[30px] [&_p:last-child]:pointer-events-none [&_p:last-child]:cursor-auto"
          classNameContent="mt-[10px]"
          classNameContainer="pl-[65px]"
          value={isConsentAccepted}
          onChange={handleConsentToggle}
          disabled={!consent || pending}
          dataTest="consent-checkbox"
          expand
          pending={consentsLoading}
        >
          <Placeholder loading={!consent}>
            <span
              className="flex flex-col items-center text-secondary cursor-pointer text-[13px] min-h-[25px] relative select-none disabled:cursor-not-allowed [&_p:first-child]:mt-0 [&_ol]:pl-[10px] [&_li]:mb-5 [&_a]:text-primary [&_a]:font-medium"
              dangerouslySetInnerHTML={{
                __html: consent || '',
              }}
              data-test="welcomeBack-consent-text"
            />
          </Placeholder>
        </Checkbox>
      </div>
    </>
  );
}
